import { useEffect, useState } from "react";
import Services from "../../services/services";
import { toast } from "react-toastify";


const CreateDepositPopup = ({ handleClose, handleCreated }) => {
    const [dataDepositMethods, setDataDepositMethods] = useState([]);

    const [amount, setAmount] = useState(0);
    const [methodCallback, setMethodCallback] = useState(0);
    // PayPal fee calculator states
    const [paypalReceive, setPaypalReceive] = useState(0);
    const [mbSend, setMbSend] = useState(0);

    // MB Bank conversion
    const mbRate = 17500;
    const handleMbReceiveChange = (e) => {
        const receive = Number(e.target.value);
        setAmount(receive);
        setMbSend(Number(receive ? Math.ceil(receive * mbRate) : 0));
    };
    // PayPal fee formula
    const calcReceive = (send) => Math.max(0, send * (1 - 0.0349) - 0.49);
    const calcSend = (receive) => Math.ceil(((receive + 0.49) / (1 - 0.0349)) * 100) / 100;

    // Sync input changes
    const handlePaypalSendChange = (e) => {
        const send = Number(e.target.value);
        setAmount(send);
        setPaypalReceive(Number(send ? calcReceive(send).toFixed(2) : 0));
    };
    const handlePaypalReceiveChange = (e) => {
        const receive = Number(e.target.value);
        setPaypalReceive(receive);
        setAmount(Number(receive ? calcSend(receive).toFixed(2) : 0));
    };

    const fetchDepositMethods = async () => {
        const res = await Services.Deposit.getDepositMethods();
        const data = await res.json();
        if (res.status === 200 && data.success === true) {
            setDataDepositMethods(data.data || []);
        }
        else {
            toast.error(`${res.status}: ${data.error ?? ""}`)
        }
    };

    // Fetching data
    useEffect(() => {
        fetchDepositMethods();
    }, []);


    const handleCreateDeposit = async () => {
        const res = await Services.Deposit.create(amount, methodCallback);
        const data = await res.json();
        if (res.ok && data.success) {
            toast.success("Deposit request created successfully! Please send money to the account of the corresponding method you have chosen. Include the Message code for confirmation")
            handleCreated(data.data);
        } else {
            toast.error(`${res.status}: ${data.error ?? ""}`)
        }
    }

    return <div className="fixed inset-0 flex items-center justify-center bg-gray-900 bg-opacity-50">
        <div className="bg-white p-6 rounded shadow-lg">
            <h2 className="text-lg font-bold mb-4">How many USD do you want to deposit?</h2>
            <div className="gap-3 flex flex-col items-center">
                <div className="flex items-center gap-3">
                    <label className="block font-bold">Method</label>
                    <select className="w-64 h-10 p-2 rounded border" onChange={(e) => setMethodCallback(e.target.value)}>
                        <option value={0}></option>
                        {dataDepositMethods.map(method => (
                            <option key={method.id} value={method.callback}>{method.name}</option>
                        ))}
                    </select>
                </div>
                {methodCallback === "paypal" ?
                    <div className="flex flex-col items-center gap-2 w-full mb-2">
                        <div className="mb-1 gap-2 flex items-center font-bold">Send 
                            <input type="number" className="border rounded p-1 w-24 mx-1" value={amount} onChange={handlePaypalSendChange} min={0} /> 
                            USD to receive
                            <input type="number" className="border rounded p-1 w-24 mx-1" value={paypalReceive} onChange={handlePaypalReceiveChange} min={0} /> 
                            USD
                        </div>
                        <div className="text-sm text-red-500 italic">cause of Paypal fees</div>
                    </div>
                    : methodCallback === "mb_bank" ?
                    <div className="flex flex-col items-center gap-2 w-full mb-2">
                        <div className="mb-1 gap-2 flex items-center font-bold">Send {mbSend} VND to receive
                            <input type="number" className="border rounded p-1 w-24 mx-1" value={amount} onChange={handleMbReceiveChange} min={0} /> 
                            USD
                        </div>
                        <div className="text-sm text-red-500 italic">17,500 VND = 1 USD</div>
                    </div>
                    :
                    <div className="flex flex-col items-center gap-2 w-full mb-2">
                        
                    <div className="flex items-center gap-3">
                        <label className="block font-bold">Amount (USDT) :</label>
                        <input type="number" className="border rounded p-2 w-64 h-10" value={amount} onChange={(e) => setAmount(Number(e.target.value))} />
                    </div>
                        <div className="text-sm text-red-500 italic">1 USDT = 1 USD</div>
                    </div>
                }
            </div>
            <div className="mt-4 flex gap-5 justify-center">
                <button className="bg-red-500 w-20 h-9 text-white  rounded" onClick={() => handleClose()}>
                    Cancel
                </button>
                <button className="bg-blue-500 w-20 h-9 text-white rounded" onClick={() => handleCreateDeposit()}>
                    Next
                </button>
            </div>
        </div>
    </div>
}
export default CreateDepositPopup;